import { RouterProvider } from "@tanstack/react-router";
import { router } from "./app/router";
import { DataProvider } from "./data/provider";
import { appI18n } from "./features/auth/i18n";
import { useWeightUnit } from "./stores/weight-unit";

/**
 * The app: the router, and the one provider slot around it.
 *
 * `DataProvider` (query client, persisted cache, session, outbox — T11) wraps
 * `RouterProvider` HERE, the only provider this file is meant to hold.
 */
export function App() {
  // Keyed on the locale: a language switch re-renders every screen at once,
  // including memoised message calls the React Compiler cached (T51).
  const locale = appI18n.useLocale();
  // And on the weight unit (`D266`), for the same reason: the formatters in
  // `lib/weight.ts` read it synchronously, so only a remount repaints them.
  const unit = useWeightUnit();
  return (
    <DataProvider>
      <RouterProvider key={`${locale}|${unit}`} router={router} />
    </DataProvider>
  );
}
